 <!-- pass data in 24 hr format - HH:mm -->

 <template>
  <v-menu
    :close-on-content-click="false"
    v-model="menu"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-on="on"
        v-model="formattedTime"
        :label="label"
        :prepend-icon="noIcon ? '' : 'access_time'"
        :rules="rules"
        readonly
        :disabled="readonly"
        :error-messages="errorMessages"
        :error="error"
        :solo="solo"
      />
    </template>

    <v-time-picker
      v-if="menu && !readonly"
      v-model="time"
      :min="min"
      :max="max"
      :format="hr24"
      :allowed-hours="computedHours"
    />
  </v-menu>
</template>

<script>
import moment from "moment";
import {mapGetters} from "vuex";
export default {
  name: "VuetifyTimepicker",
  props: [
    "value",
    "label",
    "readonly",
    "min",
    "max",
    "rules",
    "noIcon",
    "allowedHours",
    "errorMessages",
    "error",
    "disabled",
    "solo",
  ],
  mounted() {
    this.time = this.value;
  },
  data() {
    return {
      menu: false,
      time: "00:00",
    };
  },
  methods: {},
  computed: {
    formattedTime() {
      const format = this.timePreference24Hour == 14 ? "HH:mm" : "h:mm a";
      return moment(this.time, "HH:mm").format(format);
    },
    computedHours() {
      let hrs = [];
      if (!this.allowedHours || !Array.isArray(this.allowedHours)) {
        for (let i = 0; i < 24; i++) {
          hrs.push(i);
        }
      } else {
        return this.allowedHours;
      }
    },
    ...mapGetters([
      "timePreference24Hour"
    ]),
    hr24() {
      return this.timePreference24Hour == 14 ? '24hr' : 'ampm';
    }
  },
  watch: {
    time: function (newVal) {
      this.$emit("input", newVal);
      this.$emit("change", newVal);
    },
    value: function (newVal) {
      this.time = newVal;
    },
  },
};
</script>
